import { ProductKind } from '../product'

export const alwaysSelectedInstructionKinds = new Set<ProductKind>([
  ProductKind.BILLING_ADDRESS,
  ProductKind.VAT_NUMBER,
  ProductKind.REFERENCE,
  ProductKind.PRODUCTION_COMMENTS,
  ProductKind.PROPERTY_OWNER,
])
